<template>
  <div
    id="app"
    :class="{'is-responsive': isResponsivePages}"
  >
    <Indicator />
    <router-view />
    <vue-progress-bar />
    <section
      v-if="showsScrollTop"
      v-scroll="handleScroll"
    >
      <transition name="slide">
        <div
          v-if="position > 700"
          id="page_top"
        >
          <a v-scroll-to="'body'">
            <span class="boss-icon boss-icon-angle-up-solid pega-icon-page-top" />
          </a>
        </div>
      </transition>
    </section>
  </div>
</template>

<style lang="scss">
@use './styles/global' as *;
</style>

<style scoped>
.slide-enter-active, .slide-leave-active {
  transition: all .5s linear;
}
.slide-enter, .slide-leave-to {
  transform: translateY(80px);
}
</style>

<script>
import _ from 'lodash'
import Indicator from '@/components/atoms/Indicator'
import { hideAllPoppers } from 'floating-vue'

export default {
  name: 'App',
  components: {
    Indicator
  },
  data () {
    return {
      position: 0
    }
  },
  computed: {
    isResponsivePages () {
      const notResponsivePages = ['/scouts', '/print_preview', '/interview_candidate', '/interview_information', '/settings', '/dashboard', '/dummy']
      return !_.some(notResponsivePages, value => _.includes(this.$route.path, value))
    },
    showsScrollTop () {
      const isPreviewSpPage = this.$route.name?.endsWith('PreviewSp')
      const notShowsScrollTopPages = ['entryPrintPreview', 'scoutSearch', 'dummyTop']
      return !isPreviewSpPage && notShowsScrollTopPages.every(page => page !== this.$route.name)
    }
  },
  mounted () {
    // スクロール時に、ツールチップを削除する
    window.addEventListener('scroll', this.hideAllTooltips)
  },
  beforeDestroy () {
    // eventListenerの削除
    window.removeEventListener('scroll', this.hideAllTooltips)
  },
  methods: {
    handleScroll () {
      this.position = window.scrollY
    },
    hideAllTooltips () {
      hideAllPoppers() // 表示しているツールチップの削除
    }
  }
}
</script>
